/*
 *
 */

import toastr from 'toastr';
export default class Alert {

    constructor($view) {

        this.$view = $view;
        this.$alert = this.$view.find('#AlertId');
        this.Init();
    }

    Init() {
        let self = this;
        if (this.$alert.data().result.toLowerCase() == "false") {
            toastr.options = {
                timeOut: 0,
                extendedTimeOut: 0
            };
            toastr.error(this.$alert.data().message);
        } else if (this.$alert.data().result.toLowerCase() == "true") {
            toastr.options = {
                timeOut: 0,
                extendedTimeOut: 0
            };
            toastr.success(this.$alert.data().message);
        } else if (this.$alert.data().result.toLowerCase() == "info") {
            toastr.options = {
                timeOut: 0,
                extendedTimeOut: 0
            };
            toastr.info(this.$alert.data().message);
        }


    }
}